// Provide a "System" global.
module.exports = {
	// Make sure import is only used as "System.import"
	import: function() {
		throw new Error("System.import cannot be used indirectly");
	}
};



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/system.js
// module id = 83
// module chunks = 0